import { render, staticRenderFns } from "./MTHBioAgeWidget.vue?vue&type=template&id=6bfb7dd3&scoped=true&"
import script from "./MTHBioAgeWidget.vue?vue&type=script&lang=js&"
export * from "./MTHBioAgeWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfb7dd3",
  null
  
)

export default component.exports